import React from "react";
import { FiFile, FiX } from "react-icons/fi";
import { FilePreviewItemProps } from "../../types/messages.types";
import { FILE_TYPE_LABELS } from "../../constants/messages.constants";

/**
 * FilePreview Component
 * Displays preview of attached files with remove button
 */
const FilePreview: React.FC<FilePreviewItemProps> = ({
  preview,
  index,
  chatId,
  onRemove,
}) => {
  const getLabel = () => {
    return FILE_TYPE_LABELS[preview.type] || "File";
  };

  return (
    <div className="relative w-20 h-20 rounded-lg overflow-hidden border-2 border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 group">
      {preview.type === "image" && preview.content ? (
        <img
          src={preview.content}
          alt="Preview"
          className="w-full h-full object-cover"
        />
      ) : preview.type === "video" && preview.content ? (
        <video src={preview.content} className="w-full h-full object-cover" />
      ) : (
        <div className="flex flex-col items-center justify-center h-full text-neutral-600 dark:text-neutral-300 p-2">
          <FiFile size={24} className="mb-1" />
          <span className="text-[10px] text-center font-medium">
            {getLabel()}
          </span>
        </div>
      )}
      <button
        onClick={() => onRemove(chatId, index)}
        className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs shadow-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600"
        aria-label="Remove file"
      >
        <FiX size={14} />
      </button>
    </div>
  );
};

export default FilePreview;
